import { apiClient } from "@base/api/client";

/**
 * POST /82office/membership/api/unsubscription
 * 멤버십 해지 신청
 *
 * Error: NO_RUNNING_MEMBERSHIP - No running membership found.
 */
export async function createUnsubscriptionRequest(): Promise<void> {
  await apiClient.post("/82office/membership/api/unsubscription");
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useMutation, useQueryClient } from "@tanstack/react-query";
 * import { createUnsubscriptionRequest } from "@features/membership/api/unsubscription";
 *
 * const queryClient = useQueryClient();
 * const mutation = useMutation({
 *   mutationFn: createUnsubscriptionRequest,
 *   onSuccess: () => {
 *     queryClient.invalidateQueries({ queryKey: ["membership"] });
 *     // UnscribeCompleteDialog 표시 등
 *   },
 *   onError: (err: any) => {
 *     if (err?.response?.data?.code === "NO_RUNNING_MEMBERSHIP") {
 *       // 처리
 *     }
 *   },
 * });
 * mutation.mutate();
 */
